import { Grid } from 'components/atoms'
import styled from 'styled-components'

export const ButtonWrapper = styled(Grid)`
  justify-content: flex-end;
  margin-bottom: 30px;
`
